import { render, staticRenderFns } from "./IndividualTab.vue?vue&type=template&id=83fde178&"
import script from "./IndividualTab.vue?vue&type=script&lang=js&"
export * from "./IndividualTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports